<template>
  <div class="multiple-image-field">
    <template v-for="n in imageCount">
      <image-field :model="model" :attribute="humanAttribute(n)" :height="height" :value="values[n - 1]">
        <slot></slot>
      </image-field>
    </template>
    <p @click="addImageField"><i class="ss-icon">plus</i> New image</p>
  </div>
</template>

<script>
  import FormOptions from './mixins/form-options'
  import ImageField from './image-field'

  export default {
    mixins: [FormOptions],
    props: {
      editable: {
        default: true
      },
      removable: {
        default: true
      },
      width: String,
      height: String,
      values: {
        type: Array
      }
    },
    components: {
      ImageField
    },
    mounted () {
      if (this.values.length > 0) {
        this.imageCount = this.values.length
      } else {
        this.imageCount = 1
      }
    },
    data () {
      return {
        imageCount: 1
      }
    },
    methods: {
      addImageField () {
        this.imageCount = this.imageCount + 1
      },

      humanAttribute (n) {
        return `${this.attribute},${n - 1}`;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .image-field + .image-field {
    margin-top: $gutter / 2;
  }

  p {
    margin-bottom: $gutter;
    margin-top: $gutter / 4;
    font-weight: bold;
    cursor: pointer;

    i {
      position: relative;
      top: 2px;
    }
  }
</style>


// WEBPACK FOOTER //
// app/javascript/components/multiple-image-field.vue?f50da8cc